module.exports = __webpack_public_path__ + "img/ai-task-sentiment.55fcc322.svg";